// learning reports
import {RouteConfig} from "vue-router";
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";

const routes: Array<RouteConfig> = [
  {
    path: '/admin/reports/students-list',
    name: 'StudentList',
    meta: {requireAuth: true, layout: MasterLayout, title: 'Student list - App'},
    component: () => import(/* webpackChunkName: "student-list" */ '../views/LearningReport/StudentsList.vue')
  },
  {
    path: '/admin/reports/orders',
    name: 'OrderList',
    meta: {requireAuth: true, layout: MasterLayout, title: 'Orders - App'},
    component: () => import(/* webpackChunkName: "student-list" */ '../views/LearningReport/OrderList.vue')
  },
  {
    path: '/admin/reports/user-wise-course-enrollment',
    name: 'UserWiseCourseEnrollment',
    meta: {requireAuth: true, layout: MasterLayout, title: 'user wise course enrollment - App'},
    component: () =>
      import(/* webpackChunkName: "UserWiseCourseEnrollment" */ '../views/LearningReport/UserWiseCourseEnrollment.vue')
  },
  {
    path: '/admin/reports/course-wise-enrollment-count',
    name: 'CourseWiseEnrollmentCount',
    meta: {requireAuth: true, layout: MasterLayout, title: 'Course enrollment count - App'},
    component: () =>
      import(/* webpackChunkName: "CourseWiseEnrollmentCount" */ '../views/LearningReport/CourseWiseEnrollmentCount.vue')
  },
  {
    path: '/admin/reports/subscriptions/course-watch-duration',
    name: 'SubscriptionCourseWatchDuration',
    meta: {requireAuth: true, layout: MasterLayout, title: 'Subscription - App'},
    component: () =>
      import(/* webpackChunkName: "SubscriptionCourseWatchDuration" */ '../views/LearningReport/SubscriptionCourseWatchDuration.vue')
  },
  {
    path: '/admin/reports/subscriptions/user-watch-duration',
    name: 'SubscriptionUserWatchDuration',
    meta: {requireAuth: true, layout: MasterLayout, title: 'Subscription - App'},
    component: () =>
      import(/* webpackChunkName: "SubscriptionCourseWatchDuration" */ '../views/LearningReport/SubscriptionUserWatchDuration.vue')
  },
  {
    path: '/admin/reports/affiliate/performance',
    name: 'AffiliatePerformance',
    meta: {requireAuth: true, layout: MasterLayout, title: 'Affiliate performance report - App'},
    component: () => import(/* webpackChunkName: "affiliate-performance" */ '../views/LearningReport/AffiliatePerformance.vue')
  },
  {
    path: '/admin/reports/affiliate/performance/:referrer_id/plan-wise',
    name: 'AffiliatePerformancePlanWise',
    meta: {requireAuth: true, layout: MasterLayout, title: 'AffiliatePerformancePlanWise - App'},
    component: () => import(/* webpackChunkName: "affiliate-performance" */ '../views/LearningReport/AffiliatePerformancePlanWise.vue')
  },
  {
    path: '/admin/reports/affiliate/refer-and-earn-sales-report',
    name: 'ReferAndEarnSalesReport',
    meta: {requireAuth: true, layout: MasterLayout, title: 'ReferAndEarnSaleReport - App'},
    component: () => import(/* webpackChunkName: "ReferAndEarnSalesReport" */ '../views/LearningReport/ReferAndEarnSaleReport.vue')
  },
  {
    path: '/admin/reports/subscription/revenue',
    name: 'SubscriptionRevenue',
    meta: {requireAuth: true, layout: MasterLayout, title: 'Subscription revenue report - App'},
    component: () => import('../views/LearningReport/SubscriptionRevenue.vue')
  },
  {
    path: '/admin/reports/subscription/usage',
    name: 'SubscriptionUsage',
    meta: {requireAuth: true, layout: MasterLayout, title: 'Subscription usage report - App'},
    component: () => import('../views/LearningReport/SubscriptionUsage.vue')
  },
  {
    path: '/admin/reports/unsubscription',
    name: 'UnsubscriptionReport',
    meta: {requireAuth: true, layout: MasterLayout, title: 'Unsubscription report - App'},
    component: () => import('../views/LearningReport/UnsubscriptionReport.vue')
  },
  {
    path: '/admin/reports/subscription/user-details',
    name: 'SubscriptionUserwiseDetailsReport',
    meta: {requireAuth: true, layout: MasterLayout, title: 'User-wise details report - App'},
    component: () => import('../views/LearningReport/SubscriptionUserwiseDetailsReport.vue')
  },
  {
    path: '/admin/reports/point-disbursement',
    name: 'PointDisbursementReport',
    meta: {requireAuth: true, layout: MasterLayout, title: 'Point disbursement report - App'},
    component: () => import(/* webpackChunkName: "PointDisbursementReport" */ '../views/LearningReport/PointDisbursementReport.vue')
  },
];

export default routes;
